export default [
    'an',
    'auf',
    'hinter',
    'in',
    'neben',
    'über',
    'unter',
    'vor',
    'zwischen'
];